module.exports = __webpack_public_path__ + "static/media/chiapas_sancristobalTortillas.2eb2e7c8.png";